import {ReplaceInsurance} from '../fna';
import {Dropdown} from './dropdown';

const REPLACE_POLICY_OPTIONS_FR: Dropdown<ReplaceInsurance>[] = [
  {name: 'Remplacer', value: ReplaceInsurance.YES},
  {name: 'Je ne sais pas', value: ReplaceInsurance.UNKNOWN},
  {name: 'Conserver', value: ReplaceInsurance.NO},
];

const REPLACE_POLICY_OPTIONS_EN: Dropdown<ReplaceInsurance>[] = [
  {name: 'Replace', value: ReplaceInsurance.YES},
  {name: `I don't know`, value: ReplaceInsurance.UNKNOWN},
  {name: 'Keep', value: ReplaceInsurance.NO},
];

export const REPLACE_POLICY_OPTIONS = {
  en: REPLACE_POLICY_OPTIONS_EN,
  fr: REPLACE_POLICY_OPTIONS_FR,
};
